import { render, staticRenderFns } from "./narasi.vue?vue&type=template&id=ff702e8a&scoped=true&"
import script from "./narasi.vue?vue&type=script&lang=js&"
export * from "./narasi.vue?vue&type=script&lang=js&"
import style0 from "./narasi.vue?vue&type=style&index=0&id=ff702e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff702e8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VToolbar})
